import React from 'react'

import { LinkButton } from '@/shared/components/ui/link-button'

export function BasicUrlField({ value }: { value: string | null | undefined }) {
	return (
		<div className='cell-data-text'>
			{value ? (
				<LinkButton asChild>
					<a href={value} target='_blank' rel='noopener noreferrer'>
						{value}
					</a>
				</LinkButton>
			) : (
				'-'
			)}
		</div>
	)
}
